import React from 'react';

const CheckCircle = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3337 8.99935C17.3337 13.6017 13.6027 17.3327 9.00033 17.3327C4.39795 17.3327 0.666992 13.6017 0.666992 8.99935C0.666992 4.39697 4.39795 0.666016 9.00033 0.666016C13.6027 0.666016 17.3337 4.39697 17.3337 8.99935ZM12.3589 6.47407C12.603 6.71815 12.603 7.11388 12.3589 7.35793L8.19224 11.5246C7.94816 11.7687 7.55249 11.7687 7.30838 11.5246L5.64172 9.85793C5.39764 9.61385 5.39764 9.21818 5.64172 8.9741C5.88579 8.73002 6.28153 8.73002 6.5256 8.9741L7.75033 10.1988L9.61266 8.33643L11.4751 6.47407C11.7192 6.23 12.1148 6.23 12.3589 6.47407Z"
      fill="#17A39C"
    />
  </svg>
);

export default CheckCircle;
